import { Typography, Button, Box, IconButton, Dialog } from '@mui/material';
import { ReactComponent as CloseIcon } from './../../assets/icons/close-cross.svg';
import { ReactComponent as CheckIcon } from './../../assets/icons/check.svg';
import { ReactComponent as ThumbsUpIcon } from './../../assets/icons/thumbs-up.svg';


export function ThankYouPopUp ({ title='', text='', buttonText='', open = false, onClose = () => {}, onGiveFeedback }) {

    const style = {
        dialogPaper: {
            borderRadius: '1.5rem',
            padding: '3.5rem 2rem 2rem 2rem',
            maxWidth: '90%',
            width: '400px',
            position: 'relative',
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1.5rem',
        },
        closeButton: {
            position: 'absolute',
            top: '0.5rem',
            right: '1rem',
        },
        firstCheckCircle: {
            width: '3.7rem',
            height: '3.7rem',
            borderRadius: '50%',
            backgroundColor: '#56A6C3',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        secondCheckCircle: {
            width: '5rem',
            height: '5rem',
            borderRadius: '50%',
            backgroundColor: '#D3E8F0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        checkIcon: {
            width: '3rem',
            height: '3rem',
        },
        title: {
            fontSize: '1.5rem',
            fontWeight: 700,
            textAlign: 'center',
            color: '#000000',
            maxWidth: '15rem',
        },
        description: {
            textAlign: 'center',
            color: '#000000',
            wordWrap: 'break-word',
            fontWeight: 300,
        },
        button: {
            backgroundColor: '#56A6C3',
            color: 'white',
            textTransform: 'none',
            borderRadius: '2rem',
            padding: '0.8rem 2rem',
            fontSize: '1rem',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            '&:hover': {
                backgroundColor: '#4A94AF',
            },
        },
        thumbsUpIcon: {
            width: '1.2rem',
            height: '1.2rem',
        },
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{
                sx: style.dialogPaper
            }}
        >
            <Box sx={style.content}>
                <IconButton sx={style.closeButton} onClick={onClose}>
                    <CloseIcon style={{ width: '1.75rem', height: '1.75rem' }} />
                </IconButton>
                <Box sx={style.secondCheckCircle}>
                    <Box sx={style.firstCheckCircle}>
                        <CheckIcon style={style.checkIcon} />
                    </Box>
                </Box>

                {title && <Typography variant="h3" sx={style.title}>
                    {title}
                </Typography>
                }

                {text && <Typography variant='h4'sx={style.description}>
                   {text}
                </Typography>
                }

                { buttonText && onGiveFeedback && <Button variant="contained" sx={style.button} onClick={onGiveFeedback}>
                    <ThumbsUpIcon style={style.thumbsUpIcon} />
                    {buttonText}
                </Button>
                }
            </Box>
        </Dialog>
    );
}

export default ThankYouPopUp;